import {Component, OnInit, inject} from '@angular/core';
import {
  AmplitudeService
} from '@brightside-web/desktop/data-access/shared';
import { ListData } from '@brightside/brightside-ui';
import { IdentityVerification } from '../identity-verification';
import { companyList } from './select-employer.list';

import {
  AwsApiWrapperService,
  BsAuthService
} from "@brightside-web/desktop/data-access/core-services";

import {forkJoin, from, of} from "rxjs";

interface HrModalDetails {
  title: string;
  prompt: string;
  brightsideWebFb: {event_name: string, custom ? : {}};
  firebase ? : {};
}

@Component({
  templateUrl: './select-employer.component.html',
})
export class SelectEmployerComponent extends IdentityVerification implements OnInit {

  bsAuthService = inject(BsAuthService);

  displayList = false;
  showHrModal: boolean;
  defaultTitle: string;
  defaultPrompt: string;

  hrModalDetails: HrModalDetails = {
    title: 'ERROR_NOT_AVAILABLE_TITLE',
    prompt: 'ERROR_NOT_AVAILABLE_PROMPT',
    brightsideWebFb: { event_name: 'employer_not_supported_shown' },
    firebase: {
      action: 'dismiss',
      page: 'ineligible_client_modal',
      category: 'registration',
    },
  };

  employerList: ListData[] = [];
  defaultEmployerList: ListData[] = companyList;

  override processing = false;
  company: string;
  customerNumber: string;

  private amplitudeService = inject(AmplitudeService);
  private awsApiWrapperService = inject(AwsApiWrapperService);


  constructor() {
    super();
    this.defaultTitle = 'ERROR_NOT_AVAILABLE_TITLE';
    this.defaultPrompt = 'ERROR_NOT_AVAILABLE_PROMPT';
  }

  ngOnInit(): void {
    const fromSubdomain$ = from(this.bsCacheService.getItem('fromSubdomain'));
    const bypassEmployerSelection$ = from(this.bsCacheService.getItem('bypassEmployerSelection'));

    forkJoin([fromSubdomain$, bypassEmployerSelection$]).subscribe(([fromSubdomain, bypassEmployerSelection]) => {
      if (fromSubdomain || bypassEmployerSelection) {
        this.displayList = false;
        this.onCompanySelected(this.companyService.getCompany(), true);
      } else {
        this.displayList = true;
        this.loadCompanyList();
      }
    });
  }

  private loadCompanyList() {
    this.registrationService.companyList().subscribe(
      (newCompanyList: ListData[]) => {
        this.employerList = newCompanyList || this.defaultEmployerList;
      },
      (_: any) => {
        this.employerList = this.defaultEmployerList;
      }
    );
  }


  private showModal() {
    this.showHrModal = true;
    this.processing = false;
    this.error = true;
  }

  private closeModal() {
    this.showHrModal = false;
    this.processing = false;
    this.error = false;
  }

  private fetchCompanyFile(file: string = ''): void {
    if (file === '') {
      if (this.company) {
        file = this.company.toLowerCase();
      } else {
        file = 'app';
      }
    }

    this.awsApiWrapperService.get('api-mobile-noauth', `/cdn-resource/resources/configs/${file}.json`, {body: null})
      .then((data) => {
        this.customerNumber = data.supportNumber;
        this.bsCacheService.setItem('supportNumber', this.customerNumber);
      })
      .catch((_) => {
        if (file !== 'app') {
          this.fetchCompanyFile('app');
        } else {
          console.error(`Error, fallback failed~`);
        }
      });
  }

  onCompanySelected(code: string, fromSubdomain = false) {
    if (!fromSubdomain) this.analytics.logEvent('collect_employer_tapped');
    this.companyService.setCompany(code);
    this.company = code;
    this.processing = true;
    const payload = {
      company: code
    };
    this.fetchCompanyFile();
    this.sub.add(
      this.registrationService
        .postProvisional(payload, '3')
        .subscribe(
          response => {
            const type = response.type;
            this.bsCacheService.setItem('customerType', type);
            if (response.status && response.status === 'onboarding') {
              this.hrModalDetails.title = 'ERROR_EMPLOYER_ONBOARDING_TITLE';
              this.hrModalDetails.prompt = 'ERROR_EMPLOYER_ONBOARDING_DESC';
              this.hrModalDetails.brightsideWebFb = { event_name: 'employer_not_supported', custom: {type: response.status} };
              this.showModal();
            } else {
              this.sub.add(
                from(this.bsAuthService.fetchUserAttributes()).subscribe(
                  (attributes) => {
                    this.analytics.setProperties(payload);
                    this.amplitudeService.setUserProperties(payload);
                      of(this.analytics.setupRemoteConfig()).subscribe(
                        () => {
                          this.router.navigate(['registration', 'type']);
                        }
                      );
                  }
                )
              );
            }
          },
          error => {
            const errorResp = typeof error?.response?.data === 'object' ? error.response.data : {};
            const statusCode = error?.response?.status || 400;
            switch (statusCode) {
                case 402:
                  this.hrModalDetails.title = "ERROR_EMPLOYER_TITLE";
                  this.hrModalDetails.prompt = "ERROR_EMPLOYER_DESC";
                  this.hrModalDetails.brightsideWebFb = { event_name: 'employer_not_supported_shown' };
                  this.showModal();
                  break;
                case 404:
                  this.router.navigate(['/']);
                  break;
                case 429:
                  this.router.navigate(['registration', 'type']);
                  break;
                default:
                  this.hrModalDetails.title = this.defaultTitle;
                  this.hrModalDetails.prompt = this.defaultPrompt;
                  this.showModal();
                  break;
              }
          }
        )
    );
  }


  onDismiss() {
    this.analytics.logEvent(`${this.hrModalDetails.brightsideWebFb.event_name}_dismissed`);
    this.closeModal();
  }
}
